import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-column gap-3 w-25rem" };
const _hoisted_2 = { class: "font-bold text-900 block mb-2" };
const _hoisted_3 = { class: "font-medium text-900 block mb-2" };
import OverlayPanel from "primevue/overlaypanel";
import { ref } from "vue";
import Divider from "primevue/divider";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InfoIcon',
    props: {
        title: {},
        tooltip: {}
    },
    setup(__props) {
        const props = __props;
        const tooltipPanel = ref(null);
        const toggle = (event) => {
            if (tooltipPanel.value)
                tooltipPanel.value.toggle(event);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.tooltip)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "pi pi-info-circle",
                        style: { "margin-left": "10px", "color": "var(--orange-500)" },
                        onClick: toggle
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_unref(OverlayPanel), {
                    ref_key: "tooltipPanel",
                    ref: tooltipPanel
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1),
                                _createVNode(_unref(Divider)),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(props.tooltip), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
